const messagingScreenReducer = (state = {}, action) => {

  switch (action.type) {

    case "completelogout": {

      return {


      }
    }
    case "addVideoChatId": {
      var {videoChatId} = action
      return {
        ...state,
        videoChatId
      }

    }
    case "onAcceptVideoChatRequest": {
      var {videoChat} = action
      return {
        ...state,
        videoChatId: videoChat.id
      }

    }
    case "initConversationResponse": {

      return {
        ...state,

        ...action.conversation,
        messages: action.conversation.messages

      }

    }
    case "conversationUpdate": {

      return {
        ...state,

        ...action.conversation,
        messages: action.conversation.messages

      }

    }
    default:
      return state;
  }

}

export default messagingScreenReducer;


// WEBPACK FOOTER //
// ./src/Components/MessagingScreen/reducer/index.js